import { Box, Typography } from '@mui/material';
import { useAppSelector } from 'hooks';
import { ProfessionGenericRecommendationCard } from 'portfolio3/features/pdf/components/cards';
import { RecommendationProbeMappedData } from 'portfolio3/features/proforientation/model/selectors/recommendations';
import { activeFormatSelector } from 'selectors/drawers';

type RecommendationProbesSectionProps = {
  data: RecommendationProbeMappedData[];
};

const RecommendationProbesSection = ({ data }: RecommendationProbesSectionProps) => {
  const format = useAppSelector(activeFormatSelector);

  return (
    <Box className="recommendation-probes">
      <Typography variant="Headings/H5">Пробы</Typography>
      <Box marginTop="16px" className="recommendation-probes__content">
        <Box display="grid" gridTemplateColumns={format === 'horizontal' ? '1fr 1fr' : '1fr'} gap="16px">
          {data.map((event) => {
            return (
              <ProfessionGenericRecommendationCard
                key={event.eventId}
                date={event.formattedDate}
                industry={event.industry}
                name={event.name}
                place={event.place}
                district={event.district}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default RecommendationProbesSection;
